import { render } from "./DictTypesEdit.vue?vue&type=template&id=fa2bc87a"
import script from "./DictTypesEdit.vue?vue&type=script&lang=js"
export * from "./DictTypesEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__